import { initMeganavToggle } from './megaNavToggle';
import { clickToEraseSearch } from './clickToEraseSearch';

const headerInit = () => {
  initMeganavToggle();
  clickToEraseSearch();

  const isAnnouncementBarActive = document.getElementsByClassName('announcement-bar'); 
  const body = document.querySelector('[data-body]'); 
  
  if (isAnnouncementBarActive.length > 0) {
    body.classList.add('announcement-bar-active');
  } else {
    body.classList.remove('announcement-bar-active');
  }
};

export default headerInit;
